import { render, staticRenderFns } from "./CurrentFight.vue?vue&type=template&id=20c1d76c&scoped=true&lang=pug&"
import script from "./CurrentFight.vue?vue&type=script&lang=js&"
export * from "./CurrentFight.vue?vue&type=script&lang=js&"
import style0 from "./CurrentFight.vue?vue&type=style&index=0&id=20c1d76c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1d76c",
  null
  
)

export default component.exports